export default {
  apiUrl: "https://sapi.spiralbound.in/",
  mainWebsiteUrl: "https://test.spiralbound.in/",
};
